
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class RacingGroupT3Index extends Vue {}
